module.exports = __webpack_public_path__ + "static/media/whatsapp-small.57d06211.png";